{
  "devmode": {
    "Authentication": "Authentication",
    "Banner": "Banner",
    "Explain": "Explain",
    "authentication": {
      "tokenStore": "Token Store"
    },
    "crypto": {
      "meta": "Meta data",
      "secret": "Secret"
    },
    "language": "Language",
    "localStorage": "Local Storage",
    "Debug": "Debug",
    "FeatureFlags": "Feature Flags",
    "Hide": "Hide",
    "Intent": "Intent",
    "Filters": "Filters",
    "Sessions": "Sessions",
    "sessions": {
      "sessions": "Sessions",
      "messages": "Messages"
    },
    "Translate": "Translation",
    "translation": {
      "title": "Translate",
      "errors": "Errors",
      "notFound": "Not Found",
      "used": "Used"
    },
    "Search": " Search",
    "search": {
      "aiAssistant": "AI Assistant",
      "count": "Count",
      "finished": "Finished",
      "immediate": "Immediate",
      "guiFilters": "GUI Filters",
      "paging": "Paging",
      "pageInResult": "Paging in Result",
      "pageInDebug": "Paging in Debug",
      "submit": "Submit"
    }
  }
}